import type { SvgComponent } from '@/types/SvgComponent';

export const HandIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}

      <path
        d="M15.7501 7.125C15.7501 6.62772 15.9477 6.15081 16.2993 5.79917C16.6509 5.44754 17.1279 5.25 17.6251 5.25C18.1224 5.25 18.5993 5.44754 18.951 5.79917C19.3026 6.15081 19.5001 6.62772 19.5001 7.125V14.25C19.5001 15.2349 19.3061 16.2102 18.9292 17.1201C18.5523 18.0301 17.9999 18.8569 17.3034 19.5533C16.607 20.2497 15.7802 20.8022 14.8703 21.1791C13.9603 21.556 12.985 21.75 12.0001 21.75C7.85826 21.75 6.30482 19.755 3.25138 13.3125C3.00666 12.8821 2.94213 12.3723 3.07185 11.8945C3.20158 11.4167 3.51504 11.0096 3.94383 10.762C4.37262 10.5144 4.88193 10.4465 5.36061 10.5731C5.83928 10.6996 6.24848 11.0104 6.49888 11.4375L8.25013 14.25V5.625C8.25013 5.12772 8.44768 4.65081 8.79931 4.29917C9.15094 3.94754 9.62785 3.75 10.1251 3.75C10.6224 3.75 11.0993 3.94754 11.451 4.29917C11.8026 4.65081 12.0001 5.12772 12.0001 5.625"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.25V4.125C12 3.62772 12.1975 3.15081 12.5492 2.79917C12.9008 2.44754 13.3777 2.25 13.875 2.25C14.3723 2.25 14.8492 2.44754 15.2008 2.79917C15.5525 3.15081 15.75 3.62772 15.75 4.125V11.25"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
